// Lansco branding theme

export const lanscoPalette = {
  primary: {
    main: '#c21718',
    light: '#e93939',
    dark: '#990000',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#4d4d4d',
    light: '#74716B',
    dark: '#333333',
    contrastText: '#ffffff',
  },
  text: {
    primary: '#484848',
    secondary: '#524D46',
  },
  background: {
    default: '#ffffff',
    paper: '#ffffff',
  },
};

export const lanscoTypography = {
  fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
  h1: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 300,
    fontSize: '2.5rem',
  },
  h2: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 300,
    fontSize: '2rem',
  },
  h3: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 400,
    fontSize: '1.75rem',
  },
  h4: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 400,
    fontSize: '1.5rem',
  },
  h5: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 600,
    fontSize: '1.25rem',
  },
  h6: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 600,
    fontSize: '1rem',
  },
  body1: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
  },
  body2: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
  },
  button: {
    fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none' as const,
  },
};